<template>
    <div class="row justify-content-between">
        <input type="hidden" :value="Validate">
        <div class="col-12 col-sm-12 col-md-6 col-lg-7 col-xl-7" v-if="ShowDivSubMenu"
            style="max-height: 60svh; overflow-y: auto;">
            <div class="list-group">
                <h4 class="mb-2 mt-3">Descripción</h4>
                <div class="list-group-item list-group-item-action" v-for="(lista, index) in ListaDependiente"
                    :key="index">
                    <div class="row my-1 align-items-center">
                        <div class="col-12 col-sm-12 col-md-6 col-lg-5 col-xl-5 text-truncate text-left">
                            <label class="col-form-label">{{ lista.Nombre }}</label>
                        </div>
                        <div class="col-12 col-sm-12 col-md-6 col-lg-7 col-xl-7 text-right">
                            <button v-show="lista.button.Status == 0" type="button"
                                @click="MostrarPermisosxMenu(lista.IdPanel, lista);"
                                class="btn btn-primary mb-0 btn-sm me-2">
                                <i class="far fa-eye"></i>
                                <span class="tiptext"> Permisos</span>
                            </button>
                            <button type="button" @click="ActivaDependiente(lista.button, lista.IdPanel);"
                                :class="lista.button.Class" :disabled="DisabledSMAP">
                                <i :class="lista.button.Icon"></i> {{ lista.button.Text }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 col-sm-12 col-md-6 col-lg-5 col-xl-5 bg-feed">
            <CLoader :pConfigLoad="ConfigLoad" class="mt-4">
                <template slot="BodyFormLoad">
                    <h4 class="mb-3">Permisos en: {{ NombreDependiente }}</h4>
                    <div class="row" v-for="(data, index) in ListaPermisosxMenu" :key="index">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-start">
                            <div class="d-flex align-items-center m-1">
                                <div class="form-check">
                                    <input type="checkbox" v-model="data.checked" class="form-check-input"
                                        values="data.IdPermiso" style="padding-top: 1px;" />
                                </div>
                                <div>
                                    <label class="fs-5 fw-normal mb-0">
                                        {{ data.Nombre }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row" v-if="ListaPermisosxMenu.length > 0">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-end">
                            <button type="button" vif="segurity.Save"
                                @click="GuardarPermisosxUsuario(ListaPermisosxMenu[0].IdPanel);"
                                class="btn btn-primary mb-2" :disabled="ButtonSavePermiso.DisabledSave">
                                <i :class="ButtonSavePermiso.Icono"></i> {{ ButtonSavePermiso.TxtButton }}
                            </button>
                        </div>
                    </div>
                </template>
            </CLoader>
        </div>
    </div>
</template>

<script>
const BUTTONSTYLES = {
    Activate: {
        Class: 'btn mb-0 btn-sm btn-primary',
        Icon: 'far fa-check',
        Text: 'Activar menú',
        Status: 1,
    },
    Deactivate: {
        Class: 'btn mb-0 btn-sm btn-danger',
        Icon: 'far fa-ban',
        Text: 'Desactivar menú',
        Status: 0,
    }
}
export default {
    name: 'ViewDependiente',
    props: ['pArreglo', 'pObjMenu', 'pShowDivSubMenu', 'pLimpiar'],
    components: {},
    data() {
        return {
            ConfigLoad: {
                ShowLoader: false,
                ClassLoad: false,
            },
            ButtonSavePermiso: {
                TxtButton: 'Guardar',
                Icono: 'fa fa-plus-circle',
                DisabledSave: false,
            },
            NombreDependiente: '',
            DisabledSMAP: false,
            ShowDivSubMenu: true,
            MenuxUsuario: {},
            ListaDependiente: [],
            ListaPermisosxMenu: [],
            segurity: {},
        }
    },
    methods: {
        // MANDAMOS A GUARDAR EL SUB MENU, APARTADOS O SUBAPARTADO DEL Usuario Y CAMBIAMOS ESTATUS DE LOS BOTONES
        ActivaDependiente(obj, IdMenu) {
            this.LimpiarPermisos();
            var txtOrigen = obj.Text;
            var icoOrigen = obj.Icon;
            this.DeshabilitarBotonSubMenu(true, txtOrigen, icoOrigen, obj);

            let ObjSend = {
                IdMenu: IdMenu,
                IdUsuario: this.MenuxUsuario.IdUsuario,
                BtnAccion: obj.Status,
                TipoMenu: 'SubMenu'
            };

            this.$http.post('usuariosxPermiso', ObjSend).then((res) => {
                this.DeshabilitarBotonSubMenu(false, txtOrigen, icoOrigen, obj);

                if (res.data.exist > 0) {
                    if (obj.Status == 1) {
                        Object.assign(obj, BUTTONSTYLES.Deactivate)
                    } else {
                        Object.assign(obj, BUTTONSTYLES.Activate)

                    }
                } else {
                    this.$toast.error(err.response.data.message);
                }
            }).catch((err) => {
                this.DeshabilitarBotonSubMenu(false, txtOrigen, icoOrigen, obj);
                this.$toast.error(err.response.data.message);
            }).finally(() => {
                this.bus.$emit('RefrescaVista');
            });
        },
        // MOSTRAMOS EL LISTADO DE PERMISOS DE CADA SUBMENU O APARTADO
        MostrarPermisosxMenu(IdMenu, item) {
            this.NombreDependiente = item.Nombre;
            // LIMPIAMOS LOS SELECCIONADOS PARA Q NO SE QUEDEN ALMACENADOS.
            this.LimpiarPermisos();
            this.ConfigLoad.ShowLoader = true;
            this.$http.get('usuariosxPermiso/permisos', {
                params: {
                    IdMenu: IdMenu,
                    IdUsuario: this.MenuxUsuario.IdUsuario
                }
            }).then((res) => {
                res.data.Permisos.forEach(elem => {
                    elem['checked'] = res.data.PermisoxUsuario.some(elem2=> elem2.IdPermiso == elem.IdPermiso)
                }) 
                this.ListaPermisosxMenu = res.data.Permisos;
                this.segurity = res.data.segurity;

                res.data.PermisoxUsuario.forEach((value, index) => {
                    this.ListaPermisosChecked.push(value.IdPermiso)
                });
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        // GUARDAMOS TODOS LOS PERMISOS
        GuardarPermisosxUsuario(IdMenu) {
            this.DeshabilitarBotonGuardar(true);
            let arrPermisos = [];
            this.ListaPermisosxMenu.forEach(elem =>{
                if(elem.checked) arrPermisos.push(elem.IdPermiso)
            })
            this.$http.get('usuariosxPermiso/addpermisos', {
                params: {
                    IdMenu: IdMenu,
                    IdUsuario: this.MenuxUsuario.IdUsuario,
                    ArrayPermisos: arrPermisos
                }
            }).then((res) => {
                this.DeshabilitarBotonGuardar(false);
                this.$toast.success('Información guardada');
            }).catch((err) => {
                this.DeshabilitarBotonGuardar(false);
                this.$toast.error(err.response.data.message);
            });
        },
        // LIMPIAMOS LOS ARREGLOS DE PERMISOS Y PERMISOS CHECADOS
        LimpiarPermisos() {
            this.ListaPermisosxMenu = [];
            this.ListaPermisosChecked = [];
        },
        DeshabilitarBotonSubMenu(bnd, txt, ico, obj) {
            this.DisabledSMAP = false;
            obj.BtnTexto = txt;
            obj.BtnIcono = ico;

            if (bnd) {
                this.DisabledSMAP = true;
                obj.Text = ' Espere...';
                obj.Icon = 'fa fa-spinner fa-pulse';
            }

        },
        DeshabilitarBotonGuardar(bnd) {
            this.ButtonSavePermiso.DisabledSave = false;
            this.ButtonSavePermiso.TxtButton = 'Guardar';
            this.ButtonSavePermiso.Icono = 'fa fa-plus-circle';

            if (bnd) {
                this.ButtonSavePermiso.DisabledSave = true;
                this.ButtonSavePermiso.TxtButton = ' Espere...';
                this.ButtonSavePermiso.Icono = 'fa fa-spinner fa-pulse';
            }
        }
    },
    computed: {
        Validate() {
            if (this.pArreglo != undefined) {
                this.ListaDependiente = this.pArreglo;
            }
            if (this.pObjMenu != undefined) {
                this.MenuxUsuario = this.pObjMenu;
            }
            if (this.pShowDivSubMenu != undefined) {
                this.ShowDivSubMenu = this.pShowDivSubMenu;
                if (this.ShowDivSubMenu) {
                    this.ConfigLoad.ShowLoader = false;
                }
            }
            if (this.pLimpiar) {
                this.NombreDependiente = '';
                this.LimpiarPermisos();
            }

            return this.MenuxUsuario.IdUsuario;
        }
    }
}
</script>